<div id="cover-landing" class="text-white bg-primary lg:pt-0 pt-[5rem] flex justify-center items-center">
  <div
    class="container mx-auto flex flex-col lg:flex-row justify-center lg:justify-start items-center lg:items-start px-5 text-center lg:text-start pt-32 pb-[10rem]">

    <div class="contact lg:w-1/2 w-full">
      <h1 class="text-primary capitalize font-bold mb-5 xl:text-5xl lg:text-4xl md:text-3xl text-2xl leading-tight">
        Flashcards to Practice Active Recall
      </h1>
      <p class="lg:text-lg text-[#2D2E32] leading-[1.8] mx-auto lg:mx-0">
        Our digital flashcards are designed to help students master key concepts and
        strengthen memory through active recall. Aligned with IB, A Level, AS Level, IGCSE,
        GCSE, CBSE, and ICSE syllabuses, they work alongside past papers, revision notes,
        and exam-style questions. </p>
      <div class="mb-12 md:mb-2 sm:mb-2 mt-5 flex lg:justify-start justify-center items-center">
        <!-- <app-main-btn
          [btnTxColor]="'white'"
          [borderColor]="'primary'"
          [btnColor]="'primary'"
          [btnName]="'Explore Flashcards'" /> -->
      </div>
    </div>

    <div class="lg:w-1/2 mt-10 lg:mt-0 flex justify-center">
      <img src="Images/flash-stat.png" alt="flash" class="w-[60%] max-w-sm lg:max-w-full" />
    </div>

  </div>
</div>